export const BuildingTypeList = ["Commercial", "Residential", "Other"] as const;

export type BuildingType = typeof BuildingTypeList[number];
